import React, { useState, useEffect } from "react";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import { DatePickerInput } from "rc-datepicker";
import { FormGroup } from "react-bootstrap";
import localization from "assets/localization/localization";
import Regex from "services/utils/regex/Regex";
import Images from "assets/images/imageData";

const BaBusinessListFilterForm = ({
                             applyFilter,
                             reportees = [],
                             cities = [],
                             zones = [],
                             getZones,
                             getAreas,
                             isRoleId
                         }) => {
    const filterInputs = {
        leadID: "",
        clientNameOrPartnerName: "",
        city: "",
        zone: "",
        leadOwnerOrAssignee:""
    };

    const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
    const [listStatus, setListStatus] = useState("");
    const [leadOwner, setLeadOwner] = useState("");


    useEffect(() => {
        (async () => {
            const roles = await JSON.parse(
                localStorage.getItem("applyFilter") &&
                localStorage.getItem("applyFilter")
            );
            const status = await JSON.parse(
                localStorage.getItem("statusFilter") &&
                localStorage.getItem("statusFilter")
            );
            if (roles && status) {
                setFilterFieldsData(roles);
                setListStatus(status);
            }
        })();
    }, []);


    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                applyFilter(filterFieldsData);
                filterFieldsData && localStorage.setItem("applyFilter", JSON.stringify(filterFieldsData));
                listStatus && localStorage.setItem("statusFilter", JSON.stringify(listStatus));
            }}
        >
            <ConstantInput
                label={localization.leadNumber}
                value={filterFieldsData && filterFieldsData.leadID}
                regex={Regex.number.test(filterFieldsData && filterFieldsData?.leadID)}
                type="number"
                handleChange={(val) => {
                    setFilterFieldsData({ ...filterFieldsData, leadID: val });
                }}
            />
            <ConstantInput
                label={localization.clientBuildingOrPartnerName}
                value={filterFieldsData && filterFieldsData.clientNameOrPartnerName}
                regex={Regex.text.test(
                    filterFieldsData && filterFieldsData?.clientNameOrPartnerName
                )}
                type="text"
                handleChange={(val) =>
                    setFilterFieldsData({
                        ...filterFieldsData,
                        clientNameOrPartnerName: val,
                    })
                }
            />
            <DropDownInput
                disabled={reportees.length === 0}
                label={localization.leadOwnerOrAssignee}
                data={reportees}
                getIdValue={(val) =>{
                    setFilterFieldsData({
                        ...filterFieldsData,
                        leadOwnerOrAssignee: val.id,
                    })
                    setLeadOwner(val.value)
                }
                }
                value={leadOwner && leadOwner}
            />
            {/*<DropDownInput*/}
            {/*    disabled={cities.length === 0}*/}
            {/*    label={localization.city}*/}
            {/*    data={cities}*/}
            {/*    getIdValue={(val) => {*/}
            {/*        setFilterFieldsData({ ...filterFieldsData, city: val.id });*/}
            {/*        getZones(val.id);*/}
            {/*    }}*/}
            {/*    value={filterFieldsData && filterFieldsData.city}*/}
            {/*/>*/}

            {/*<DropDownInput*/}
            {/*    disabled={zones.length === 0}*/}
            {/*    label={localization.zone}*/}
            {/*    data={zones.length ? zones : []}*/}
            {/*    getIdValue={(val) => {*/}
            {/*        setFilterFieldsData({ ...filterFieldsData, zone: val.id });*/}

            {/*    }}*/}
            {/*    value={filterFieldsData && filterFieldsData.zone}*/}
            {/*/>*/}

            {/*<DropDownInput*/}
            {/*    disabled={zones.length === 0}*/}
            {/*    label={localization.area}*/}
            {/*    data={zones.length ? zones : []}*/}
            {/*    getIdValue={(val) => {*/}
            {/*        setFilterFieldsData({ ...filterFieldsData, zone: val.id });*/}

            {/*    }}*/}
            {/*    value={filterFieldsData && filterFieldsData.zone}*/}
            {/*/>*/}

            <br />
            <br />
            <br />

            <div className="btn-wrapper">
                <button disabled={false} type="submit" className="btn btn-primary">
                    {localization.applyFilter}
                    <img src={Images?.ArrowRight} alt="" />
                </button>
                <br/>
                <br/>
                <button
                    onClick={() => {
                        localStorage.setItem("applyFilter", JSON.stringify(filterInputs));
                        applyFilter(filterInputs);
                        localStorage.setItem("statusFilter", JSON.stringify({}));
                    }}
                    type="button"
                    className="btn btn-primary"
                >
                    {localization.removeFilter}
                </button>
            </div>
        </form>
    );
};

export default BaBusinessListFilterForm;
